import React, { Component } from "react";

export default class AddConferences extends Component {
  render() {
    return <div>Add in conferance</div>;
  }
}
